import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
import util from '@/libs/util';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'ByMemberResourceEdit',
  data: function data() {
    return {
      uploadUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      fileList: [],
      title: '',
      props: {
        multiple: false
      },
      citys: [],
      citys2: [],
      marriages: [],
      educations: [],
      form: {
        selectCitys: [],
        selectCitys2: [],
        nativeCity: [],
        sex: null,
        age: null,
        education: null,
        marriage: null,
        resourceInfo: null,
        redNurseAccount: null,
        birthday: null,
        file: null
      },
      rules: {
        selectCitys: [{
          required: true,
          message: '请选择城市',
          trigger: 'blur'
        }],
        sex: [{
          required: true,
          message: '请选择性别',
          trigger: 'blur'
        }],
        age: [{
          required: true,
          message: '请选择出生年月',
          trigger: 'blur'
        }],
        birthday: [{
          required: true,
          message: '请选择出生年月',
          trigger: 'blur'
        }],
        marriage: [{
          required: true,
          message: '请选择婚史',
          trigger: 'blur'
        }],
        education: [{
          required: true,
          message: '请选择学历',
          trigger: 'blur'
        }],
        birthDate: [{
          required: true,
          message: '请输入出生日期',
          trigger: 'blur'
        }],
        resourceInfo: [{
          required: true,
          message: '请输入资源详情',
          trigger: 'blur'
        }],
        redNurseAccount: [{
          required: true,
          message: '请输入关联红娘',
          trigger: 'blur'
        }],
        selectCitys2: [{
          required: true,
          message: '请选择籍贯',
          trigger: 'blur'
        }],
        file: [{
          required: true,
          message: '请上传文件',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      // this.form.urlImg = res.body.dnsUrl + '/' + res.body.url
      this.fileList.push(file);
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    getEducationsEnumList: function getEducationsEnumList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: 'mbmber_education_select'
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.educations = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getMarriagesEnumList: function getMarriagesEnumList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: 'mbmber_marriage_select'
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this2.marriages = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    initCitys: function initCitys() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.GET_BYCITYOPENING_TREE_LIST({});
            case 1:
              res = _context3.v;
              _this3.citys = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    initCitys2: function initCitys2() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.GET_BYCITYOPENING_SELECT_TREE_LIST2({});
            case 1:
              res = _context4.v;
              _this4.citys2 = res.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    initEunmData: function initEunmData() {
      this.initCitys();
      this.initCitys2();
      this.getMarriagesEnumList();
      this.getEducationsEnumList();
    },
    getEnumList: function getEnumList(name) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                name: name
              };
              _context5.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context5.v;
              _this5.enumList = res.body;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.initEunmData();
      this.fileList = [];
      this.form.education = null;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.initEunmData();
      this.fileList = [];
      this.form.education = null;
    },
    updateApi: function updateApi() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return api.UPDATE_BYMEMBERRESOURCE(_this6.form);
            case 1:
              _this6.$emit('initTableData');
              _this6.$message.success('操作成功');
              _this6.handleClose();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    saveApi: function saveApi() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return api.saveByMemberResource(_this7.form);
            case 1:
              _this7.$emit('initTableData');
              _this7.$message.success('操作成功');
              _this7.handleClose();
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    save: function save() {
      var _this8 = this;
      if (this.fileList.length > 0) {
        var files = [];
        this.fileList.forEach(function (file) {
          file.response.body.url = _this8.downloadUrl + file.response.body.url;
          files.push(file.response.body);
        });
        this.form.file = JSON.stringify(files);
      }
      this.form.pushSts = 1;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this8.saveApi();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};